<script>
	import { getContext } from 'svelte';

	const { data, xGet, yGet, yRange, xScale } = getContext('LayerCake');
		
	$: columnWidth = () => {
		if($data[0].values.length <= 60) {
			return 5;
		} else {
			return 2;
		}
	
	};

	$: columnHeight = d => {
		return $yRange[0] - $yGet(d);
	};

	
	/* --------------------------------------------
	* Default styles
	*/
	export let fill = '#C7C7C7';
	export let stroke = '';
	export let strokeWidth = 0;
	
</script>

<g class="column-group">
	{#each $data[0].values as d, i}
		<rect
			class='group-rect'
			data-id="{i}"
			x="{$xScale(d[0])-(columnWidth()/2)}"
			y="{$yGet(d)}"
			width="{columnWidth()}"
			height="{columnHeight(d)}"
			{fill}
			{stroke}
			stroke-width="{strokeWidth}"
		/>
	{/each}
</g>


<style lang="scss">
	.group-rect {
		fill: #f89090;
	}	
</style>